export const constructionMob = require('./constructionMob.png?webp');
export const construction = require('./construction.png?webp');
export const mining = require('./mining.png?webp');
export const miningMob = require('./miningMob.png?webp');
export const forestryMob = require('./forestryMob.png?webp');
export const forestry = require('./forestry.png?webp');
